"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.loadEmailPreviewEpic = void 0;

var _operators = require("rxjs/operators");

var _utils = require("@alycecom/utils");

var _services = require("@alycecom/services");

var _giftEmailPreview = require("./giftEmailPreview.actions");

var loadEmailPreviewEpic = function loadEmailPreviewEpic(action$, state$, _ref) {
  var createGiftService = _ref.createGiftService;
  return action$.pipe((0, _utils.ofType)(_giftEmailPreview.fetchEmailPreviewData.pending), (0, _operators.switchMap)(function (_ref2) {
    var _ref2$payload = _ref2.payload,
        giftId = _ref2$payload.giftId,
        provider = _ref2$payload.provider;
    return createGiftService.getEmailPreview(giftId, provider).pipe((0, _operators.map)(function (_ref3) {
      var data = _ref3.data;
      return _giftEmailPreview.fetchEmailPreviewData.fulfilled(data);
    }), (0, _operators.catchError)((0, _services.handleError)(_services.handlers.handleAnyError(_giftEmailPreview.fetchEmailPreviewData.rejected()))));
  }));
};

exports.loadEmailPreviewEpic = loadEmailPreviewEpic;
var _default = [loadEmailPreviewEpic];
exports.default = _default;